// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ActionBar from '../../layout/ActionBar';
import {
  saveTerritory,
  getTerritoryById,
} from '../../../actions/territoryActions';
import Loading from '../../common/Loading';
import AllowedSkuList from './components/AllowedSkuList';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';

function AllowedSkus({ saveTerritory }) {
  const { id } = useParams();
  const [pageTitle, setPageTitle] = usePageTitle([
    'Allowed SKUs',
    'Territories',
    'Settings',
  ]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [reload] = useState();
  const [territory, setTerritory] = useState({});

  useEffect(() => {
    if (id) {
      getTerritoryById(id)
        .then((d) => {
          setTerritory(d);
          setPageTitle([d.name, 'Allowed SKUs', 'Territories', 'Settings']);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/territories/');
          toast.error(t('Territory not found'));
        });
    }
  }, [id, setPageTitle, navigate, t]);

  return territory ? (
    <>
      <ActionBar></ActionBar>

      <AllowedSkuList reload={reload} territoryId={id} />
    </>
  ) : (
    <Loading></Loading>
  );
}

const mapDispatchToProps = {
  saveTerritory,
};

export default connect(null, mapDispatchToProps)(AllowedSkus);
